export default __webpack_public_path__ + "static/media/HP3.3feeca2f.jpg";